<template>
  <div>
    <div class="container-fluid noGutter">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1497.4035334162713!2d18.77135365816756!3d42.42863897458393!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDLCsDI1JzQzLjEiTiAxOMKwNDYnMjAuOCJF!5e1!3m2!1sen!2s!4v1596108513083!5m2!1sen!2s"
        width="100%"
        height="450"
        frameborder="0"
        style="border:0;"
        allowfullscreen=""
        aria-hidden="false"
        tabindex="0"
      ></iframe>
    </div>
    <div class="container">
      <div class="row">
        <div class="col">
          <h3 class="text-center" style="color:#e6eaf0">Contact Us</h3>
          <p style="color:#e6eaf0">
            We would be please to answer all of your questions - if any! So
            don't hesitate to write whatever you want to know about us or our
            dogs. Feel free to call us if you need a quicker response!
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <img src="logo.png" width="150px" alt="image" />
        </div>
        <div class="col-md-4">
          <h3 class="text-center">Dogo di cattaro</h3>

          Kotor <br />85330, Montenegro <br />Phone: <a href="tel:+38269685018">+38269685018</a>
          <br />
          <a href="krsto.ks001@gmail.com">krsto.ks001@gmail.com </a>
          <br />
        </div>
        <div class="col-md-5">
           <h3 class="text-center">Check us on</h3>
           <div class="mb-3">
            <a
              href="https://sr-rs.facebook.com/Dogo-Di-Cattaro-992178320795339/"
              target="_blank"
            >
              <img src="facebook.png" width="40px" alt="" class="mx-4"
            /></a>
          </div>
          <div>
            <a
              href="https://www.instagram.com/dogodicattaro/?hl=sr"
              target="_blank"
            >
              <img src="instagram-sketched.png" width="40px" alt="" class="mx-4"
            /></a>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";

export default {
  components: {
    Footer,
  },
};
</script>

<style scoped>
.col-md-3 {
  background: #fdfa44;
  padding: 4%;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.col-md-4 {
  background: #fff;
  padding: 3%;
}
.col-md-5 {
  background: #fff;
  padding: 3%;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.text-center {
  text-align: center;
}
</style>
